"use strict";
exports.__esModule = true;
//# sourceMappingURL=user-notification.type.js.map